export default __webpack_public_path__ + "static/media/Gustavo Lozada Echenique.b284cf05.jpg";